// extracted by mini-css-extract-plugin
module.exports = {"body":"EABDZeroTouchContentCard_body__117WE"};